/* eslint-disable no-lonely-if */
import { Outlet } from 'react-router-dom';
import { useEmailFolders } from '../hooks/useEmailFolders';
import { EmailBoxContext } from './EmailBoxContext';

// eslint-disable-next-line import/prefer-default-export
export const GeneralPostboxProvider = () => {
  const value = useEmailFolders();

  return (
    <EmailBoxContext.Provider value={value}>
      <Outlet />
    </EmailBoxContext.Provider>
  );
};
